import React from 'react';

export const CustomerStatsCards = ({ total, statusSummary, visible }) => {
    if (!visible) {
        return null;
    }

    return (
        <div className="accordion-collapse collapse show page-header-collapse mb-3 animate__animated animate__fadeIn">
            <div className="accordion-body card__no-border">
                <div className="row g-3 mb-1">
                    <div className="col-xxl-2 col-md-6">
                        <div className="card__stat border-0 mb-0">
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="fs-12 text-muted mb-1">Total</p>
                                        <h4 className="mb-0">{total}</h4>
                                    </div>
                                    <div className="avatar-text avatar-md bg-soft-primary text-primary">
                                        <i className="feather-users"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-2 col-md-6">
                        <div className="card__stat border-0 mb-0">
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="fs-12 text-muted mb-1">Activos</p>
                                        <h4 className="mb-0">{statusSummary.ACTIVE}</h4>
                                    </div>
                                    <div className="avatar-text avatar-md bg-soft-success text-success">
                                        <i className="feather-check-circle"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-2 col-md-6">
                        <div className="card__stat border-0 mb-0">
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="fs-12 text-muted mb-1">Suspendidos</p>
                                        <h4 className="mb-0">{statusSummary.SUSPENDED}</h4>
                                    </div>
                                    <div className="avatar-text avatar-md bg-soft-warning text-warning">
                                        <i className="feather-clock"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-2 col-md-6">
                        <div className="card__stat border-0 mb-0">
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <p className="fs-12 text-muted mb-1">Inactivos</p>
                                        <h4 className="mb-0">{statusSummary.INACTIVE}</h4>
                                    </div>
                                    <div className="avatar-text avatar-md bg-soft-danger text-danger">
                                        <i className="feather-slash"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
